import { useMutation } from "react-query";
import { apiResolver, useApi } from "../useApi";
import { useWorkspace } from "@/routes/simulator/context/wrokspace";

type UseImproveParams = {
  tenantId?: string;
  message: string;
  useCase?: "chat" | "ticket";
  timeout?: number;
};

type ImproveResponse = {
  object: {
    reason: string;
    enhancments: string;
    typeOfImprovement: "instruction" | "brief" | "prerequisite";
  };
};

export function useImprove(timeout?: number) {
  const { api } = useApi();
  const { workspace } = useWorkspace();

  return useMutation({
    mutationFn: ({ tenantId, message, useCase }: UseImproveParams) =>
      apiResolver<ImproveResponse>(
        api.post("/platform/vercel-proxy/api/improve", {
          tenant: tenantId ?? workspace,
          message,
          useCase,
        })
      ),
  });
}
